import React from 'react';
import { useAppBySlug } from '../hooks/useAppBySlug';

interface AppVersionBadgeProps {
  /** App slug to look up version for, e.g. 'ats', 'kms'. */
  slug: string;
  /** Optional className for layout tweaks. */
  className?: string;
}

/**
 * Tiny version label rendered in micro-FE sidebars/footers.
 * Reads version from the workspace's PortalApp subscription, so it always
 * reflects what backend/marketplace knows about the deployed app.
 *
 * Render nothing when version is unavailable (no subscription / loading) to
 * avoid layout shifts.
 */
export const AppVersionBadge: React.FC<AppVersionBadgeProps> = ({ slug, className = '' }) => {
  const app = useAppBySlug(slug);

  if (!app?.app_version) {
    return null;
  }

  return (
    <span
      className={`text-xs font-mono text-gray-400 ${className}`}
      title={`${app.app_name} v${app.app_version}`}
    >
      v{app.app_version}
    </span>
  );
};
